module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"upgrade":"Upgrade","join":"Join","reviews":"User Reviews","click_to_join":"Click Here To Join"},"ja":{"upgrade":"アップグレード","join":"入会する","reviews":"ユーザーレビュー","click_to_join":"入会はこちら"}}')
  delete Component.options._Ctor
}
